<script>
  export let direction;
  export let x;
  export let y;
  export let fill;
</script>

{#if direction === "up"}
  <g transform="translate({x},{y})"><path d="M-7,9 L7,9 L0,0 Z" {fill} /></g>
{:else if direction === "down"}
  <g transform="translate({x},{y})"><path d="M-7,0 L7,0 L0,9 Z" {fill} /></g>
{:else}
  {@debug}
{/if}

<style>
  g {
    pointer-events: none;
  }
</style>
